import Text from '@/components/view/atoms/text/Text'

interface Props {
  page: number
  perPage: number
  total: number
  unit?: string
}

const TitlePageInfo = ({ page, perPage, total, unit = '件' }: Props) => {
  const last = page * perPage < total ? page * perPage : total

  return (
    <Text size={12}>
      {(total ? `${(page - 1) * perPage + 1}~${last} / ` : '') + `${total}${unit}`}
    </Text>
  )
}

export default TitlePageInfo
